import React, { Component } from 'react';
import styled from 'styled-components';
import media from '../../theme/media';
import { Container, ContainerLarge, Article, Heading, FirstSection, Section, MainColumn, OneHalf, OneThird, KeySection, SideColumnRightSkwiz } from '../../theme/grid';
import { OverlaySummery } from '../../theme/overlay';
import { Caption, HeadingH1, HeadingH2, DropCap } from '../../theme/typography';
import { VideoIphoneVerticalContainer } from '../../theme/video';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import PageFooter from '../../components/PageFooter/PageFooter';

const small = require('../../assets/SkwizColors/top.png');
const medium = require('../../assets/SkwizColors/top@2x.png');
const large = require('../../assets/SkwizColors/top@3x.png');

const middleSmall = require('../../assets/SkwizColors/middle.png');
const middleMedium = require('../../assets/SkwizColors/middle@2x.png');
const middleLarge = require('../../assets/SkwizColors/middle@3x.png');

const bottomSmall = require('../../assets/SkwizColors/bottom.png');
const bottomMedium = require('../../assets/SkwizColors/bottom@2x.png');
const bottomLarge = require('../../assets/SkwizColors/bottom@3x.png');

const revealSmall = require('../../assets/Skwiz/reveal.png');
const revealMedium = require('../../assets/Skwiz/reveal@2x.png');
const revealLarge = require('../../assets/Skwiz/reveal@3x.png');

const SkwizIlloTop = () => (
  <img src={small} srcSet={`${small} 300w, ${medium} 768w, ${large} 1280w`} alt=""/>
);

const SkwizIlloMiddle = () => (
  <img src={middleSmall} srcSet={`${middleSmall} 300w, ${middleMedium} 768w, ${middleLarge} 1280w`} alt=""/>
);

const SkwizIlloBottom = () => (
  <img src={bottomSmall} srcSet={`${bottomSmall} 300w, ${bottomMedium} 768w, ${bottomLarge} 1280w`} alt=""/>
);

const SkwizIlloReveal = () => (
  <img src={revealSmall} srcSet={`${revealSmall} 300w, ${revealMedium} 768w, ${revealLarge} 1280w`} alt=""/>
);

const SideColumnRightSkwizReveal = styled.div`
  position: absolute;
  width: 124px;
  right: -86px;
  top: calc(50% - 180px);
  ${media.tablet`
    order: 2;
    position: static;
    margin: 4rem auto;
  `}
`;

export default class SkwizColors extends Component {
  static propTypes = {};
  
  constructor(props) {
      super(props)

      this.handler = this.handler.bind(this);

      if (this.props.location.hash == "#present") {
        this.state = {
            messageShown: false
        };
      } else {
        this.state = {
            messageShown: true
        };
      }
  }

  handler() {
      this.setState({
          messageShown: !this.state.messageShown
      });
  }

  render() {
    return (
      <div>
      
        <Header theme={"skwiz " + this.state.messageShown} color="#485CDC" date="Spring 2019 - Present" role="Concept, Design, Development" action={this.handler}></Header>
          <Article className={"skwiz " + this.state.messageShown}>
            <Container className={this.state.messageShown}>
                <Heading className={this.state.messageShown}>
                  <HeadingH2 className="skwiz">Skwiz</HeadingH2>
                  <HeadingH1>Color Palettes</HeadingH1>
                  <OverlaySummery className={this.state.messageShown}>
                    <p>I designed the plugin to make it as easy as possible to start working with Mozilla's brand assets.</p>
                    <ul>
                      <li>Imports Layer Styles</li>
                      <li>Interchangable Layer Styles</li>
                      <li>Updates Layer Fills</li>
                    </ul>
                  </OverlaySummery>
                </Heading>
              <FirstSection className={this.state.messageShown}>
                <MainColumn>
                  <p><DropCap>A</DropCap>T it’s core Skwiz is a drawing app, and what would a drawing app be without colors. Most drawing apps, think Illustrator or Procreate, give you the option to include any color at any time without restrictions. Unlike those apps, Skwiz only gives you a few crayons to play and the results couldn’t be more spectacular.</p>
                  <p>The decision to restrain the number of colors we allow a player to draw with, came after experimenting with Apple’s built in drawing frameworks. These frameworks came with a lot of advantages (pressure sensitivity, color picker, eraser, a few different pen tools) we knew the only way to create a cohesive drawing was to limit the number of options we gave players so they would have to work with the same set of tools. </p>
                  <p>Having our own drawing engine also gave us the ability to introduce some innovative features around layering, making it that much faster to draw and the final drawing that much more consistent. We also had to give people a way of picking which colors to use which is how we came up with a system for storing color palettes.</p>
                </MainColumn>
              </FirstSection>
              
              <Section className={this.state.messageShown}>
                <img alt="" src={require('../../assets/SkwizColors/isometric-overview@2x.png')} width="100%" />
                <Caption>Drawings created by beta testers</Caption>
              </Section>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Drawing Engine</h2>
                  <p>When developing for iOS, there are a few built in frameworks at your disposal. One of those is PencilKit. Introduced in 2019, PencilKit is designed to work with Apple’s Pencil product. PencilKit can determine the angle of the pencil and the and the amount of pressure applied to the screen. PencilKit then uses those two values to change the weight and direction of the lines you draw on the screen. PencilKit also comes with a toolbar with different pen types, a color picker, and an eraser. You can see PencilKit in action when editing a photo on your iPhone.</p>
                  <p>PencilKit seemed like a great starting point, we played around with the tech implementing it’s core features into our app. It soon became apparent that all of the amazing things that Apple introduced in this toolset to make it easier to draw actually made it harder to draw Skwizes.</p>
                  <p>What we found when working on the app is that the key to a good exquisite corpse is having enough consistency between a top, middle, and bottom that it looks like an intentional collaboration and not three random images pasted on top of one another.</p>
                </MainColumn>
              </Section>
              <Section className={this.state.messageShown}>
              	<div style={{
              		position: 'absolute',
              		width: '25%',
              		bottom: '-10%',
              		right: '-100px'
              		
              	}}>
              		<img alt="" src={require('../../assets/SkwizColors/iPhone-front.png')} style={
              			{
              			position: 'absolute',
              			width: '90%',
              			top: '50%',
              			left: '50%',
              			transform: 'translate(-50%, -50%)', 
              			zIndex: '4'
              			}
              		} />
              		<img alt="" src={require('../../assets/SkwizColors/reveal.jpeg')} style={
              			{
              			position: 'absolute',
              			width: '90%',
              			top: '50%',
              			left: '50%',
              			transform: 'translate(-50%, -50%)', 
              			zIndex: '3',
              			borderRadius: '10px'
              			}
              		} />
              		<img alt="" src={require('../../assets/SkwizColors/iPhone-back.png')} width="100%" />
              	</div>
              	<img alt="" src={require('../../assets/SkwizColors/iPAD-front.png')} style={
              		{
              			position: 'absolute', 
              			width: '90%', 
              			top: '55%', 
              			left: '50%', 
              			transform: 'translate(-50%, -50%)', 
              			zIndex: '2'
              		}
              	} />
              	<img alt="" src={require('../../assets/SkwizColors/canvas.gif')} style={
              		{
              			position: 'absolute', 
              			width: '90%', 
              			top: '55%', 
              			left: '50%', 
              			transform: ' translate(-50%, -50%)', 
              			zIndex: '1',
              			borderRadius: '20px'
              		}
              	} />
              	<img alt="" src={require('../../assets/SkwizColors/iPAD-back.png')} width="100%" />
              </Section>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <p>With PencilKit we immediately ran into a number of problems. The pressure sensitive nature of the framework made it difficult to match the width of the lines from the previous drawing. PencilKit	also included unlimited color options. If a color wasn’t included as part of the preview area left for you by the previous drawer you would never know that color was used and you wouldn’t include it as part of your drawing. </p>
                  <p>So what we decided to do was build our own drawing engine that could handle layering in a unique way and restrict players to a limited number of colors and pencil sizes.</p>
                </MainColumn>
              </Section>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Layering</h2>
                  <p>In a typical drawing tool (Photoshop, Figma, etc.) layers are used to give the drawer the option of focusing on one aspect of the drawing at a time. Any designer will tell you that their files contain thousands of layers as what they are working on becomes more complex.</p>
                  <p>We were initial skeptical of including any kind of layering with Skwiz. A successful game between three players should only take a couple of minutes to complete. The longer you are waiting to draw that next part, the more frustrating the process becomes. Anytime you add complexity to the drawing process you are increasing the time it takes to complete a drawing. Layers is a whole level of complexity that we were going to ignore, until we found an innovative approach which actually speeds up the time it takes to make a drawing.</p>
                </MainColumn>
              </Section>
              <Section className={this.state.messageShown}>
              	<div>
              		<img alt="" src={require('../../assets/SkwizColors/screenshots-bottom.png')} style={
              			{
              				width: '100%'
              			}
              		} />
              		<img alt="" src={require('../../assets/SkwizColors/screenshots-top.png')} style={
              			{
              				width: '100%',
              				position: 'absolute',
              				top: '50%', 
              				left: '50%', 
              				transform: ' translate(-50%, -50%)',
              				zIndex: '99'
              			}
              		} />
              		<img alt="" src={require('../../assets/SkwizColors/scrolling.gif')} style={
              			{
              				position: 'absolute',
              				width: '26%',
              				top: '15.75%',
              				left: '5.25%',
              				zIndex: '1',
              				borderRadius: '20px',
							border: '3px solid rgba(0,0,0,0.2)'
              			}
              		} />
              		<img alt="" src={require('../../assets/SkwizColors/palette-drawings.gif')} style={
              			{
              				position: 'absolute',
							width: '26%',
							top: '7.25%',
							left: '68.5%',
							zIndex: '1',
							borderRadius: '20px',
							border: '3px solid rgba(0,0,0,0.2)'
              			}
              		} />
              		<img alt="" src={require('../../assets/SkwizColors/palette-top.gif')} style={
              			{
              				position: 'absolute',
							width: '26%',
							top: '51.5%',
							left: '21.5%',
							zIndex: '1',
							borderRadius: '20px',
							border: '3px solid rgba(0,0,0,0.2)',
							transform: 'rotate(-90deg)'
              			}
              		} />
              		</div>
              	</Section>
              	<Section className={this.state.messageShown}>
                  <MainColumn>
                      <p>A common illustration technique, linge claire, made famous by Tintin creator Hergé, uses clear strong lines to emphasize a character. Trying to draw in this style with a single layer is quite difficult. At first you draw your character in black and white, then you have to carefully draw between those black lines in color. The whole process took forever. So we thought to our selves what if there was a way we could have two layers, one for black lines and one for color lines. That way we wouldn’t have to worry about messing up those black lines when shading in a character.</p>
                  	<p>To achieve this we could’ve added a button allowing you to switch between layers, but then you could end up with two layers that include both colored and black lines. So instead of a button, we arrived at this idea that the app will automatically switch layers. Whenever you have the black pencil tool selected you are drawing in the foreground and whenever you have the color pencil tool selected you are drawing in the background. The result was spectacular. It became incredibly easy to make a fill in the space between lines without any worry about messing ups your black lines. All of the layer switching was occurring in the background, without the drawer ever having to worry.</p>
                  </MainColumn>
              </Section>
            </Container>
          </Article>
          <PageFooter present={this.state.messageShown} theme="skwiz" leftTitle="Skwiz" left="Drawing Game" leftLink="skwiz-drawing-game" rightTitle="Amazon" right="Data Plugin" rightLink="amazon-data-plugin"/>
      </div>
    );
  }
}



























// WEBPACK FOOTER //
// src/containers/SkwizColors/SkwizColors.js